import { HttpError } from '../../modules/http';
import { PaginationParams } from '../../types';

export const buildPaginationParams = (options: PaginationParams) => {
  const result: Record<string, unknown> = {
    limit: options.limit,
    offset: options.offset,
  };

  return result;
};

export const createNotFoundError = () => {
  const error = new HttpError('response');
  error.response = {
    status: 404,
  };
  return error;
};

export const unknownOptions = (options: never) =>
  new Error(`Unknown options: ${JSON.stringify(options)}`);

export const unknownBy = (by: never) => new Error(`Unknown scope: ${by}`);
